import type { RowValueType } from '@/dashboards/CompetitorsMediaInvestment/types';

export interface CompetitorImpactTotals {
    primary: number;
    comparison: number;
}

/**
 * Sums the competitor investment (media effect) across every row in the given dataset.
 */
export const sumCompetitorImpact = (rows: RowValueType | undefined): number => {
    if (!rows || rows.length === 0) {
        return 0;
    }

    return rows.reduce((acc, row) => {
        const raw = row.investment?.value.raw;
        const value = Number(raw);
        return acc + (isNaN(value) ? 0 : value);
    }, 0);
};

/**
 * Calculates primary and comparison competitor impact totals from query row sets.
 */
export const calculateCompetitorImpactTotals = (
    primaryRows: RowValueType | undefined,
    comparisonRows: RowValueType | undefined,
): CompetitorImpactTotals => ({
    primary: sumCompetitorImpact(primaryRows),
    comparison: sumCompetitorImpact(comparisonRows),
});
